import React, { useState } from "react";
//import axios from "axios";
import "./auth.css";
import api, { API_ENDPOINTS } from "../../config"; // ✅ Import API endpoints
import ThemeToggle from "../ThemeToggle"; // ✅ Import toggle

function Login() {
 const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState(""); // State for handling errors
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear any previous errors
    setLoading(true); // Start loading

    try {
      const response = await api.post(API_ENDPOINTS.Login, form, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      const data = response.data;
      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.user["role"]);
    
      
        window.location.href = "/admindashboard"; // Redirect to admin dashboard
      } else if (response.status === 401) {
        // Handle unauthorized error
        setError("Invalid credentials. Please try again.");
        setLoading(false); // Stop loading on error
      } else {
        // Handle unexpected success responses
        setError("Unexpected response. Please try again.");
      }
    } catch (error) {
      // Handle login error
      console.error("Login failed:", error);
      setError(error.response?.data?.message || "Login failed. Please try again.");
      setLoading(false); // Stop loading on error
    }
  };

  return (
    <div className="auth-container">
      {/* 🔘 Dark Mode Button */}
      <div className="auth-theme-toggle">
        <ThemeToggle />
      </div>

      <div className="auth-box">
        <h2>Login</h2>
         {error && <p className="auth-error">{error}</p>} {/* Display error message */}
        <form onSubmit={handleSubmit}>
          <input
            
            name="email"
            placeholder="email"
            // value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <button type="submit" disabled={loading}> {loading ? <span className="spinner"></span> : "Login"}
          </button>
        </form>
        <div className="auth-links">
          <a href="/reset-password">Forgot Password?</a>
          <br />
      
        </div>
      </div>
    </div>
  );
}

export default Login;
